import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createBlock as _createBlock, unref as _unref, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56bd2be1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "search-box" }
const _hoisted_3 = { class: "input-group mb-3" }
const _hoisted_4 = { class: "input-group-text" }
const _hoisted_5 = { class: "input-group-text" }
const _hoisted_6 = {
  key: 0,
  class: "card-view"
}
const _hoisted_7 = { class: "input-group-text" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "machine-info" }
const _hoisted_11 = { class: "search-info-data" }
const _hoisted_12 = { class: "search-info-data" }
const _hoisted_13 = { class: "search-info-data" }
const _hoisted_14 = { class: "data-selector" }
const _hoisted_15 = {
  for: "0",
  class: "data-selector-label"
}
const _hoisted_16 = {
  for: "1",
  class: "data-selector-label"
}
const _hoisted_17 = {
  for: "2",
  class: "data-selector-label"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "search-chart"
}
const _hoisted_21 = {
  key: 1,
  class: "search-page"
}
const _hoisted_22 = {
  key: 0,
  class: "esg-data-view"
}
const _hoisted_23 = { class: "esg-info-data" }
const _hoisted_24 = { class: "esg-info-data" }
const _hoisted_25 = { class: "esg-info-data" }
const _hoisted_26 = { class: "esg-info-data" }
const _hoisted_27 = { class: "esg-info-data" }
const _hoisted_28 = { class: "esg-info-data" }
const _hoisted_29 = { class: "esg-info-data" }
const _hoisted_30 = { class: "esg-info-data" }
const _hoisted_31 = { class: "esg-info-data" }
const _hoisted_32 = {
  key: 1,
  class: "rfid-data-view"
}
const _hoisted_33 = { class: "rfid-info-data" }
const _hoisted_34 = { class: "rfid-info-data" }
const _hoisted_35 = { class: "rfid-info-data" }
const _hoisted_36 = { class: "page-box" }
const _hoisted_37 = { "aria-label": "Page navigation" }
const _hoisted_38 = { class: "pagination justify-content-center" }
const _hoisted_39 = { "aria-hidden": "true" }
const _hoisted_40 = { "aria-hidden": "true" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { "aria-hidden": "true" }
const _hoisted_43 = { "aria-hidden": "true" }

import { ref, watchEffect, onMounted } from "vue";
import _, { findLastIndex, update } from "lodash";
import dayjs from "dayjs";
import { useRoute } from "vue-router";
import SearchTable from "../../components/SearchTable.vue";
import {
  searchAxios,
  faultAxios,
  esgAxios,
  rfidAxios,
} from "@/service/user.service";
import { getCSV } from "@/service/local/filesave.service";
import { SearchDataAnalysis } from "@/interface/search.data";
import { computed } from "@vue/reactivity";
import AppImage from "@/components/AppImage.vue";
import "vue3-loading-overlay/dist/vue3-loading-overlay.css";
import { userUseStore } from "@/store/user";

// 연습본
import SearchChart from "@/components/SearchChart.vue";
import { dataGraphAxios } from "@/service/user.service";
import router from "@/router";
import { isTemplateElement } from "@babel/types";
import { number } from "@intlify/core-base";
import { ROU_NAME } from "@/router/router.name";
// 테스트용
// import { realTimeDataAxios } from "@/service/user.service";
import { superUseStore } from "@/store/super";
import { storeToRefs } from "pinia";
import { useOptionStore } from "@/store/option";
import { celsiusToFahrenheit, gToPound, kgToPound } from "@/util/unit";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const userStore = userUseStore();
const optionStore = useOptionStore();

const time = dayjs();
// const searchSelect = ref(true);
// const searchSelect = ref({
//   machine: true,
//   fault: false,
//   esg: false,
//   card: false,
// });

const searchSelect = ref(0);

const searchGraph = ref(false);

const state = ref({
  group: "",
  manager: "",
  user: "",
  model: "",
  site: "",
  operationCount: 0,
  currentPage: 1,
  pageSlice: 5,
  startTime: time.subtract(1, "day").format("YYYY-MM-DDTHH:mm"),
  endTime: time.format("YYYY-MM-DDTHH:mm"),
  utcStartTime: time.format("YYYY-MM-DDTHH:mm"),
  utcEndTime: time.format("YYYY-MM-DDTHH:mm"),
  mac: String(route.query.mac),
  header: computed(() => {
    return [
      "Time",
      "Power_ON/OFF",
      "Status",
      // "Cycle_Status",
      "Operation_Step",
      "Alive_Count",
      "Cycle_count",
      "Dry_Time(min)",
      "Discharge_Time(min)",
      optionStore.isMetricUnit ? "Weight (Kg)" : "Weight (lb)",
      optionStore.isMetricUnit ? "Tank_Temp (°C)" : "Tank_Temp (°F)",
      "Power (kW)",
      "Energy (kWh)",
    ];
  }),
  searchData: [[]] as SearchDataAnalysis[][],
  testAAA: [[]] as any[],
  saveData: [] as SearchDataAnalysis[],
  faultHeader: ["Time", "Error"],
  faultData: [[]] as any[],
  faultSaveData: [] as any[],
  // 추가본(장비 넘버)
  esgHeader: computed(() => {
    return [
      "Time",
      optionStore.isMetricUnit ? "Input (Kg)" : "Input (lb)",
      optionStore.isMetricUnit ? "Output (Kg)" : "Output (lb)",
      "Reduction (%)",
      "Drying Time(hrs)",
      "Power(Kwh)",
    ];
  }),
  esgData: [[]] as any[][],
  esgSaveData: [] as any[],
  // 추가본
  reduction: 0,
  cardHeader: computed(() => {
    return [
      "Time",
      "Site Name",
      "Card Id",
      "Card Number",
      optionStore.isMetricUnit ? "Weight (g)" : "Weight (lb)",
    ];
  }),
  cardData: [[]] as any[][],
  cardState: false,
  cardSaveData: [] as any[],
  modelNumber: Number,
  totalDryWeight: 0,
  esgAverageDryWeight: 0,
  totalWeight: 0,
  esgAverageWeight: 0,
  totalEnergy: 0,
  esgAverageEnergy: 0,
  esgDryTime: 0,
  esgAverageDryTime: 0,
  totalEsgDryTime: 0,
  rfidDryTime: 0,
  totalRfidDryTime: 0,
  cardId: "",
  // cardNumber: "",
  // diffTime: "",
  // subDay: 0,
  rfidTotalWeight: 0,
  rfidAverageWeight: 0,
  totalCount: 0,
});

const searchData = computed(() => {
  console.log(searchData);
  return state.value.searchData.map((data) => {
    return data.map((data2) => {
      return {
        ...data2,
        weight: optionStore.isMetricUnit
          ? data2.weight
          : kgToPound(data2.weight).toFixed(2),
        tank_temp: optionStore.isMetricUnit
          ? data2.tank_temp
          : celsiusToFahrenheit(data2.tank_temp),
      };
    });
  });
});

const esgData = computed(() => {
  if (optionStore.isMetricUnit) {
    return state.value.esgData;
  }

  return state.value.esgData.map((data) => {
    return data.map((data2) => {
      return {
        ...data2,
        weight: kgToPound(data2.weight),
        dry_weight: kgToPound(data2.dry_weight),
      };
    });
  });
});

const cardData = computed(() => {
  if (optionStore.isMetricUnit) {
    return state.value.cardData;
  }

  return state.value.cardData.map((data) => {
    return data.map((data2) => {
      return {
        ...data2,
        weight: gToPound(data2.weight),
      };
    });
  });
});

//
const findMac = computed(() => {
  if (userStore.realTimeData[0]) {
    const idx = userStore.findMac(String(route.query.mac));
    console.log(`finemac : ${idx}`);
    return idx;
  } else {
    console.log(`finemac : none`);
    return 0;
  }
});

//

// 그래프 테스트본 시작
const graphData = ref({
  graph: [] as any[],
});

const cardActive = () => {
  state.value.cardState = !state.value.cardState;
};

// 그래프 테스트본 종료
const pageIdx = computed(() => {
  let nowIdx = Math.floor(state.value.currentPage / state.value.pageSlice);
  if (state.value.currentPage % state.value.pageSlice === 0) {
    if (state.value.currentPage === state.value.pageSlice) {
      nowIdx = 0;
    } else {
      nowIdx--;
    }
  }
  return nowIdx;
});

const pageList = computed(() => {
  if (searchSelect.value === 0) {
    const list = _.range(1, state.value.searchData.length + 1);
    return _.chunk(list, state.value.pageSlice);
  } else if (searchSelect.value === 1) {
    const list = _.range(1, state.value.faultData.length + 1);
    return _.chunk(list, state.value.pageSlice);
  } else if (searchSelect.value === 2) {
    const list = _.range(1, state.value.esgData.length + 1);
    return _.chunk(list, state.value.pageSlice);
  } else if (searchSelect.value === 3) {
    const list = _.range(1, state.value.cardData.length + 1);
    return _.chunk(list, state.value.pageSlice);
  } else {
    console.log("추가해야합니다");
  }
});
const pageGo = (page: number) => {
  state.value.currentPage = page;
};

const prevPage = () => {
  if (state.value.currentPage > 1) {
    state.value.currentPage--;
  }
};

const nextPage = () => {
  if (searchSelect.value === 0) {
    if (state.value.currentPage < state.value.searchData.length)
      state.value.currentPage++;
  } else if (searchSelect.value === 1) {
    if (state.value.currentPage < state.value.faultData.length)
      state.value.currentPage++;
  } else if (searchSelect.value === 2) {
    if (state.value.currentPage < state.value.esgData.length)
      state.value.currentPage++;
  } else if (searchSelect.value === 3) {
    if (state.value.currentPage < state.value.cardData.length)
      state.value.currentPage++;
  }
  //   state.value.currentPage <
  //   (state.value.searchData.length ||
  //     state.value.faultData.length ||
  //     state.value.esgData.length ||
  //     state.value.cardData.length)
  // ) {
  //   state.value.currentPage++;
  // } else {
  //   state.value.currentPage = 1;
  // }
};

const firstPage = () => {
  state.value.currentPage = 1;
};

const lastPage = () => {
  if (searchSelect.value === 0) {
    state.value.currentPage = state.value.searchData.length;
  } else if (searchSelect.value === 1) {
    state.value.currentPage = state.value.faultData.length;
  } else if (searchSelect.value === 2) {
    state.value.currentPage = state.value.esgData.length;
  } else if (searchSelect.value === 3) {
    state.value.currentPage = state.value.cardData.length;
  } else {
    console.log("추가필요");
  }
};

const timeChange = () => {
  if (searchSelect.value === 0) {
    if (
      dayjs(state.value.endTime).toDate().getTime() / 1000 / 60 / 60 / 24 -
        dayjs(state.value.startTime).toDate().getTime() / 1000 / 60 / 60 / 24 >
      7
    ) {
      state.value.endTime = dayjs(state.value.startTime)
        .add(7, "day")
        .format("YYYY-MM-DDTHH:mm");
    }
    if (
      dayjs(state.value.endTime).toDate().getTime() / 1000 / 60 / 60 / 24 -
        dayjs(state.value.startTime).toDate().getTime() / 1000 / 60 / 60 / 24 <=
      0
    ) {
      state.value.endTime = dayjs(state.value.startTime)
        .add(1, "day")
        .format("YYYY-MM-DDTHH:mm");
    }
  } else {
    if (
      dayjs(state.value.endTime).toDate().getTime() / 1000 / 60 / 60 / 24 -
        dayjs(state.value.startTime).toDate().getTime() / 1000 / 60 / 60 / 24 >
      30
    ) {
      state.value.endTime = dayjs(state.value.startTime)
        .add(30, "day")
        .format("YYYY-MM-DDTHH:mm");
    }
    if (
      dayjs(state.value.endTime).toDate().getTime() / 1000 / 60 / 60 / 24 -
        dayjs(state.value.startTime).toDate().getTime() / 1000 / 60 / 60 / 24 <=
      0
    ) {
      state.value.endTime = dayjs(state.value.startTime)
        .add(1, "day")
        .format("YYYY-MM-DDTHH:mm");
    }
  }
};

const utcCollector = async () => {
  const utcOffset = dayjs(state.value.startTime).utcOffset() * 1000 * 60;
  const start = dayjs(state.value.startTime).toDate().getTime() - utcOffset;
  const end = dayjs(state.value.endTime).toDate().getTime() - utcOffset;
  state.value.utcStartTime = dayjs(start).format("YYYY-MM-DDTHH:mm");
  state.value.utcEndTime = dayjs(end).format("YYYY-MM-DDTHH:mm");
};

const enterSearch = async () => {
  searchGraph.value = true;

  await userStore.loadingChange(0);
  await utcCollector();

  if (state.value.cardState === true) {
    state.value.cardId;
  } else {
    state.value.cardId = "";
  }

  if (state.value.utcStartTime && state.value.utcEndTime) {
    if (searchSelect.value === 0) {
      const data = await searchAxios(
        state.value.mac,
        state.value.utcStartTime,
        state.value.utcEndTime
      );
      state.value.currentPage = 1;

      const dataAnalysis = _.chain(data?.searchData)
        .map((item) => {
          return {
            update: item.UT,
            on: item.MS,
            status: item.ST,
            operation_step: item.OS,
            alive_count: item.AC,
            cycle_count: item.CT,
            dry_time: item.RT,
            discharge_time: item.RCT,
            weight: item.WT,
            tank_temp: item.TT,
            active_energy: item.TAP,
            active_power: item.TAE,
          };
        })
        .sortBy("update")
        .reverse()
        .value();

      const tmpGraphData = _.map(data?.graphData, (item) => {
        return {
          time: item.T,
          status: item.ST,
          cycle_status: item.CS,
          cycle_count: item.CT,
          weight: item.WT,
          tank_temp: item.TT,
          active_energy: item.TAP,
          active_power: item.TAE,

          operation_step: item.OS,
          oil_heater_1_temperature: item.O1,
          oil_heater_2_temperature: item.O2,
          air_heater_1_temperature: item.A1,
          air_heater_2_temperature: item.A2,
          discharge_heater_temperature: item.DT,
          door_position: item.DP,
          lift_switch_on: item.LSO,
          lift_status: item.LS,
          lift_position: item.LP,
          error_input_weight_overload: item.EWO,
          error_oil_bi_metal: item.EOB,
          error_air_bi_metal: item.EAB,
          error_motor_overload: item.EMO,
          error_blower_pump_fan_overload: item.EBO,
          error_tank_temperature_over_heating: item.ETO,
          error_oil_heater_1_over_heating: item.EO1,
          error_oil_heater_2_over_heating: item.EO2,
          error_air_heater_1_over_heating: item.EA1,
          error_air_heater_2_over_heating: item.EA2,
          error_discharge_heater_over_heating: item.ED,
          error_emergency_stop: item.EE,
          error_lift_hydric_motor: item.EL,
          // error_in_let_one_movement_error: item.NM1,
          // error_in_let_two_movement_error: item.NM2,
          // error_run_button_pressed_during_operation: item.RO,
          // error_inlet_door_open_during_operation: item.IO,
          // error_main_switch_turn_on: item.MSO,
        };
      });

      state.value.saveData = dataAnalysis;
      // 서치데이터 5개씩 출력(넘으면 다음페이지로)
      state.value.searchData = _.chunk(dataAnalysis, 5);

      graphData.value.graph = tmpGraphData;

      // 추가본
      const searchDataSave = state.value.saveData;
      userStore.chartData = searchDataSave;
      userStore.graphData = tmpGraphData;
      // 추가본

      await userStore.loadingChange(1);
    } else if (searchSelect.value === 1) {
      const data = await faultAxios(
        state.value.mac,
        state.value.utcStartTime,
        state.value.utcEndTime
      );
      state.value.currentPage = 1;
      // firstPage();
      if (data[0] === undefined) {
        await userStore.loadingChange(1);
        alert("No data");
        return;
      }

      const faultData = _.chain(data)
        .map((item) => {
          return {
            update: item.update_time,
            error: item.error_code,
          };
        })
        .sortBy("update")
        .reverse()
        .value();

      state.value.faultSaveData = faultData;
      // fault Search 데이터 5개 씩 출력하기
      state.value.faultData = _.chunk(faultData, 5);

      await userStore.loadingChange(1);
    } else if (searchSelect.value === 2) {
      const data = await esgAxios(
        state.value.mac,
        state.value.utcStartTime,
        state.value.utcEndTime
      );
      state.value.currentPage = 1;

      // 토탈 값들 구간
      const esgDataZip = userStore.esgData;

      state.value.totalDryWeight = 0;
      state.value.totalWeight = 0;
      state.value.totalEnergy = 0;
      state.value.totalEsgDryTime = 0;
      esgDataZip.forEach((item) => {
        state.value.totalWeight += item.WW;
        state.value.totalDryWeight += item.DW;
        // 추가본 아래 한줄만
        // state.value.reduction = ((item.WW - item.DW) / item.WW) * 100;
        // state.value.totalEsgDryTime += item.DT;
        state.value.totalEsgDryTime += item.DT / 60;
        state.value.totalEnergy += item.EC;
      });

      state.value.totalDryWeight =
        Math.round(state.value.totalDryWeight * 10) / 10;
      state.value.totalWeight = Math.round(state.value.totalWeight * 10) / 10;
      state.value.totalEnergy = Math.round(state.value.totalEnergy * 10) / 10;
      state.value.totalEsgDryTime =
        Math.round(state.value.totalEsgDryTime * 10) / 10;

      const inputCount = userStore.esgData.length;
      state.value.operationCount = inputCount;

      if (inputCount === 0) {
        state.value.esgAverageWeight = 0;
        state.value.esgAverageDryWeight = 0;
        state.value.esgAverageEnergy = 0;
        state.value.esgAverageDryTime = 0;
      } else {
        const averageWeight = state.value.totalWeight / inputCount;
        const averageDryWeight = state.value.totalDryWeight / inputCount;
        const averageEnergy = state.value.totalEnergy / inputCount;
        const averageDryTime = state.value.totalEsgDryTime / inputCount;

        state.value.esgAverageWeight = Math.round(averageWeight * 10) / 10;
        state.value.esgAverageDryWeight =
          Math.round(averageDryWeight * 10) / 10;
        state.value.esgAverageEnergy = Math.round(averageEnergy * 10) / 10;
        state.value.esgAverageDryTime = Math.round(averageDryTime * 10) / 10;
      }

      // reduction: ((item.WW - item.DW) / item.WW) * 100 + "%", 예시
      // toFixed를 우선 Number로 억지로 변환한 데이터
      const sortDataAnalysis = _.chain(data)
        .map((item) => {
          return {
            update: item.UT,
            // mac_addr: item.MA,
            weight: item.WW,
            dry_weight: item.DW,
            // 추가본(reduction)
            reduction: Number(
              (((item.WW - item.DW) / item.WW) * 100).toFixed(3)
            ),
            dry_time: Number((item.DT / 60).toFixed(3)),
            energy_consumption: Number(item.EC.toFixed(3)),
          };
        })
        .sortBy("update")
        .reverse()
        .value();

      userStore.reductionEsgData = sortDataAnalysis;

      state.value.esgSaveData = sortDataAnalysis;
      state.value.esgData = _.chunk(sortDataAnalysis, 13);
      await userStore.loadingChange(1);
    } else if (searchSelect.value === 3) {
      const data = await rfidAxios(
        state.value.mac,
        state.value.cardId,
        state.value.utcStartTime,
        state.value.utcEndTime
      );
      state.value.currentPage = 1;

      const totalInput = userStore.rfidData.length;

      state.value.totalCount = totalInput;

      // const totalWeight =

      state.value.rfidTotalWeight = 0;

      const rfidDataZip = userStore.rfidData;
      rfidDataZip.forEach((item) => {
        state.value.rfidTotalWeight += item.WW;
      });
      if (totalInput === 0) {
        state.value.rfidAverageWeight = 0;
      } else {
        const rfidAverageWeight = state.value.rfidTotalWeight / totalInput;

        state.value.rfidAverageWeight = Math.round(rfidAverageWeight * 10) / 10;
      }

      const dataAnalysis = _.chain(data)
        .map((item) => {
          return {
            update: item.UT,
            site_name: state.value.site,
            card_id: item.ID,
            card_number: item.CN,
            weight: item.WW,
          };
        })
        .sortBy("update")
        .reverse()
        .value();

      state.value.cardSaveData = dataAnalysis;

      state.value.cardData = _.chunk(dataAnalysis, 15);
      await userStore.loadingChange(1);
    }
  } else {
    return;
  }
};

const enterSave = async () => {
  const filename = `${sessionStorage.getItem("group")}_${sessionStorage.getItem(
    "username"
  )}_${state.value.site}_${state.value.mac}_${state.value.startTime} & ${
    state.value.endTime
  }`;
  if (searchSelect.value === 0) {
    await getCSV(filename, state.value.saveData, state.value.header);
  } else if (searchSelect.value === 1) {
    await getCSV(filename, state.value.faultSaveData, state.value.faultHeader);
  } else if (searchSelect.value === 2) {
    await getCSV(filename, state.value.esgSaveData, state.value.esgHeader);
  } else if (searchSelect.value === 3) {
    await getCSV(filename, state.value.cardSaveData, state.value.cardHeader);
  }
};

onMounted(() => {
  console.log("search page mounted");

  watchEffect(() => {
    searchSelect;
    timeChange();
    if (userStore.realTimeData[0]) {
      if (state.value.site === "") {
        state.value.site = userStore.realTimeData[findMac.value].site_name;
      }
      if (state.value.group === "") {
        state.value.group = userStore.realTimeData[findMac.value].group;
      }
      if (state.value.manager === "") {
        state.value.manager = userStore.realTimeData[findMac.value].manager;
      }
      if (state.value.user === "") {
        state.value.user = userStore.realTimeData[findMac.value].user_name;
      }
      if (state.value.model === "") {
        if (userStore.realTimeData[findMac.value].model === 1) {
          state.value.model = "ES-30";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 2) {
          state.value.model = "ES-300L FAS LIFT";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 3) {
          state.value.model = "ES-60L";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 4) {
          state.value.model = "ES-80L";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 5) {
          state.value.model = "ES-150L";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 6) {
          state.value.model = "ES-150L Regular Lift";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 7) {
          state.value.model = "ES-300L";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 8) {
          state.value.model = "ES-300L Regular Lift";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 9) {
          state.value.model = "ES-500L";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 10) {
          state.value.model = "ES-500L Regular Lift";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 11) {
          state.value.model = "ES-500L FAS LIFT";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 21) {
          state.value.model = "ES-30 R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 22) {
          state.value.model = "ES-300L FAS LIFT R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 23) {
          state.value.model = "ES-60L R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 24) {
          state.value.model = "ES-80L R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 25) {
          state.value.model = "ES-150L R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 26) {
          state.value.model = "ES-150L Regular Lift R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 27) {
          state.value.model = "ES-300L R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 28) {
          state.value.model = "ES-300L Regular Lift R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 29) {
          state.value.model = "ES-500L R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 30) {
          state.value.model = "ES-500L Regular Lift R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else if (userStore.realTimeData[findMac.value].model === 31) {
          state.value.model = "ES-500L FAS LIFT R";
          state.value.modelNumber = Number(
            userStore.realTimeData[findMac.value].model
          );
        } else {
          state.value.model = `Unknown model : ${state.value.model}`;
        }
      }
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("start_time")), 1),
        _withDirectives(_createElementVNode("input", {
          onChange: timeChange,
          type: "datetime-local",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.value.startTime) = $event))
        }, null, 544), [
          [_vModelText, state.value.startTime]
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("end_time")), 1),
        _withDirectives(_createElementVNode("input", {
          onChange: timeChange,
          type: "datetime-local",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.value.endTime) = $event))
        }, null, 544), [
          [_vModelText, state.value.endTime]
        ]),
        (searchSelect.value === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("input", {
                  type: "checkbox",
                  class: "card-check",
                  id: "card-check",
                  name: "cardstate",
                  value: "cardcheck",
                  onClick: cardActive
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("card_search")), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                onChange: timeChange,
                type: "text",
                class: "form-control",
                for: "cardcheck",
                disabled: state.value.cardState === false,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.value.cardId) = $event))
              }, null, 40, _hoisted_8), [
                [_vModelText, state.value.cardId]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn-search",
          onClick: enterSearch
        }, _toDisplayString(_ctx.$t("search")), 1),
        _createElementVNode("button", {
          class: "btn-save",
          onClick: enterSave,
          disabled: 
            state.value.saveData.length === 0 &&
            state.value.faultSaveData.length === 0 &&
            state.value.esgSaveData.length === 0 &&
            state.value.cardSaveData.length === 0
          
        }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("site")) + " : " + _toDisplayString(state.value.site), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("model")) + " : " + _toDisplayString(state.value.model), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("user")) + " : " + _toDisplayString(state.value.user), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchSelect).value = $event)),
            value: 0,
            type: "radio",
            name: "dataSelect",
            id: "0"
          }, null, 512), [
            [_vModelRadio, searchSelect.value]
          ]),
          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("machine_data")), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchSelect).value = $event)),
            value: 1,
            type: "radio",
            name: "dataSelect",
            id: "1"
          }, null, 512), [
            [_vModelRadio, searchSelect.value]
          ]),
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("fault_data")), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchSelect).value = $event)),
            value: 2,
            type: "radio",
            name: "dataSelect",
            id: "2"
          }, null, 512), [
            [_vModelRadio, searchSelect.value]
          ]),
          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("esg_search")), 1),
          _withDirectives(_createElementVNode("input", {
            disabled: state.value.modelNumber < 20,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchSelect).value = $event)),
            value: 3,
            type: "radio",
            name: "dataSelect",
            id: "3",
            class: "card-search"
          }, null, 8, _hoisted_18), [
            [_vModelRadio, searchSelect.value]
          ]),
          _createElementVNode("label", {
            for: "3",
            class: "card-search-label",
            disabled: state.value.modelNumber < 20
          }, _toDisplayString(_ctx.$t("card_search")), 9, _hoisted_19)
        ])
      ])
    ]),
    (searchSelect.value === 0 || searchSelect.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          (searchGraph.value === true)
            ? (_openBlock(), _createBlock(SearchChart, {
                key: 0,
                graph: graphData.value.graph
              }, null, 8, ["graph"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (searchSelect.value === 2 || searchSelect.value === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (searchSelect.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("operation_count")) + " : " + _toDisplayString(state.value.operationCount), 1),
                _createElementVNode("span", _hoisted_24, [
                  _createTextVNode(_toDisplayString(_ctx.$t("total_weight")) + " : ", 1),
                  (_unref(optionStore).isMetricUnit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(state.value.totalWeight) + "(Kg) ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(kgToPound)(state.value.totalWeight)) + "(lb) ", 1)
                      ], 64))
                ]),
                _createElementVNode("span", _hoisted_25, [
                  _createTextVNode(_toDisplayString(_ctx.$t("total_dry_weight")) + " : ", 1),
                  (_unref(optionStore).isMetricUnit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(state.value.totalDryWeight) + "(Kg) ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(kgToPound)(state.value.totalDryWeight)) + "(lb) ", 1)
                      ], 64))
                ]),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("total_dry_time")) + " : " + _toDisplayString(state.value.totalEsgDryTime) + "(hrs) ", 1),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("total_energy")) + " : " + _toDisplayString(state.value.totalEnergy) + "(kWh) ", 1),
                _createElementVNode("span", _hoisted_28, [
                  _createTextVNode(_toDisplayString(_ctx.$t("average_weight")) + " : ", 1),
                  (_unref(optionStore).isMetricUnit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(state.value.esgAverageWeight) + "(Kg) ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(kgToPound)(state.value.esgAverageWeight)) + "(lb) ", 1)
                      ], 64))
                ]),
                _createElementVNode("span", _hoisted_29, [
                  _createTextVNode(_toDisplayString(_ctx.$t("average_dry_weight")) + " : ", 1),
                  (_unref(optionStore).isMetricUnit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(state.value.esgAverageDryWeight) + "(Kg) ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(kgToPound)(state.value.esgAverageDryWeight)) + "(lb) ", 1)
                      ], 64))
                ]),
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("average_dry_time")) + " : " + _toDisplayString(state.value.esgAverageDryTime) + "(hrs) ", 1),
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("average_energy")) + " : " + _toDisplayString(state.value.esgAverageEnergy) + "(kWh) ", 1)
              ]))
            : _createCommentVNode("", true),
          (searchSelect.value === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("input_count")) + " : " + _toDisplayString(state.value.totalCount), 1),
                _createElementVNode("span", _hoisted_34, [
                  _createTextVNode(_toDisplayString(_ctx.$t("total_weight")) + " : ", 1),
                  (_unref(optionStore).isMetricUnit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(state.value.rfidTotalWeight) + "(g) ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(gToPound)(state.value.rfidTotalWeight)) + "(lb) ", 1)
                      ], 64))
                ]),
                _createElementVNode("span", _hoisted_35, [
                  _createTextVNode(_toDisplayString(_ctx.$t("average_weight")) + " : ", 1),
                  (_unref(optionStore).isMetricUnit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(state.value.rfidAverageWeight) + "(g) ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(gToPound)(state.value.rfidAverageWeight)) + "(lb) ", 1)
                      ], 64))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["search-data", 
        searchSelect.value === 2
          ? 'long-search-data'
          : '' || searchSelect.value === 3
          ? 'long-search-data2'
          : ''
      ])
    }, [
      (searchSelect.value === 0)
        ? (_openBlock(), _createBlock(SearchTable, {
            key: 0,
            headers: state.value.header,
            items: _unref(searchData)[state.value.currentPage - 1]
          }, null, 8, ["headers", "items"]))
        : (searchSelect.value === 1)
          ? (_openBlock(), _createBlock(SearchTable, {
              key: 1,
              headers: state.value.faultHeader,
              items: state.value.faultData[state.value.currentPage - 1]
            }, null, 8, ["headers", "items"]))
          : (searchSelect.value === 2)
            ? (_openBlock(), _createBlock(SearchTable, {
                key: 2,
                headers: state.value.esgHeader,
                items: _unref(esgData)[state.value.currentPage - 1]
              }, null, 8, ["headers", "items"]))
            : (_openBlock(), _createBlock(SearchTable, {
                key: 3,
                headers: state.value.cardHeader,
                items: _unref(cardData)[state.value.currentPage - 1]
              }, null, 8, ["headers", "items"])),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("nav", _hoisted_37, [
          _createElementVNode("ul", _hoisted_38, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item first-page", { disabled: state.value.currentPage === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                onClick: firstPage
              }, [
                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("first")), 1)
              ])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item prev-page", { disabled: state.value.currentPage === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                onClick: prevPage
              }, [
                _createElementVNode("span", _hoisted_40, [
                  _createVNode(AppImage, { name: "prev_icon" })
                ])
              ])
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageList)[_unref(pageIdx)], (page, idx) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["page-item current-page", { active: page === state.value.currentPage }]),
                key: idx
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  onClick: ($event: any) => (pageGo(page)),
                  href: "#"
                }, _toDisplayString(page), 9, _hoisted_41)
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item next-page", {
                disabled:
                  searchSelect.value === 0
                    ? state.value.currentPage === state.value.searchData.length
                    : searchSelect.value === 1
                    ? state.value.currentPage === state.value.faultData.length
                    : searchSelect.value === 2
                    ? state.value.currentPage === state.value.esgData.length
                    : searchSelect.value === 3
                    ? state.value.currentPage === state.value.cardData.length
                    : 0,
              }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                onClick: nextPage
              }, [
                _createElementVNode("span", _hoisted_42, [
                  _createVNode(AppImage, { name: "next_icon" })
                ])
              ])
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item last-page", {
                disabled:
                  searchSelect.value === 0
                    ? state.value.currentPage === state.value.searchData.length
                    : searchSelect.value === 1
                    ? state.value.currentPage === state.value.faultData.length
                    : searchSelect.value === 2
                    ? state.value.currentPage === state.value.esgData.length
                    : searchSelect.value === 3
                    ? state.value.currentPage === state.value.cardData.length
                    : 0,
              }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                onClick: lastPage
              }, [
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("last")), 1)
              ])
            ], 2)
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})